import React from 'react'

const Error = () => {
  return (
    <div>
      <p className="text-xl px-4 py-2 bg-red-400 text-white font-semibold  rounded-md">
        An error occurred......!
      </p>
    </div>
  );
}

export default Error